import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import PropTypes from 'prop-types';

import StartPage from './Pages/StartPage';
import ChangeArea from './Pages/ChangeArea';
import CurrentWH from './Pages/CurrentWH';
import changePage from '../../Actions/Assessment/changePage';
import CurrentAct from './Pages/CurrentAct';
import CurrentSmoking from './Pages/CurrentSmoking';
import CurrentAlcohol from './Pages/CurrentAlcohol';
import LivewellReview from './Pages/LivewellReview';
import CurrentPregnant from './Pages/CurrentPregnant';
import AllResults from './Pages/AllResults';
import { validateHash } from '../../Actions/Assessment/validateHash';
import { submitAssessment } from '../../Actions/Assessment/submitAssessment';

import { pingLogin } from '../../Actions/Dashboard/login';
import api from '../../lib/api';

let gender = 'Male';

function parseQuery(queryString) {
  const query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i += 1) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}

class AssessmentForm extends React.Component {
  constructor(props) {
    super(props);

    this.finalNextPage = this.finalNextPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);

    const qs = parseQuery(window.location.search);
    const { h } = qs;

    this.setState({ h });
    this.props.dispatch(validateHash(h));

    if (this.props.login) {
      api.setToken(this.props.login);
      this.props.dispatch(pingLogin(this.props.login.access_token, this.props.login.refresh_token));

    //   const elButton = document.getElementsByClassName('js-comb-login')[0];
    //   elButton.innerText = 'Logout';
    //   elButton.onclick = function doLogout(e) {
    //     localStorage.clear();
    //     window.location = '/login';
    //     e.preventDefault();
    //   };
    }
  }

  state = {
    height: 0,
    gender: 'null',
    h: 0,
  };

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.validateHash && nextProps.validateHash.height !== this.state.height) {
      this.setState({ height: nextProps.validateHash.height, gender: nextProps.validateHash.gender });
      gender = nextProps.validateHash.gender;
      this.props.dispatch(change('assessment', 'assessment[curr_height]', nextProps.validateHash.height));
      const cm = parseInt(nextProps.validateHash.height, 10);
      if (!cm) return;
      let inc = (cm * 0.393700787).toFixed(0);
      const ft = Math.floor(inc / 12);
      inc %= 12;

      this.props.dispatch(change('assessment', 'curr_ft', ft));
      this.props.dispatch(change('assessment', 'curr_in', inc));

    }
  }

  nextPage(values) {
    let page = this.props.page + 1;
    if (page === 6 && gender === 'Male') {
      page += 1;
      this.finalNextPage(values);
    } else {
      this.props.dispatch(changePage(page));
    }
  }

  finalNextPage(values) {
    const page = 7; // this.props.page + 1;

    this.props.dispatch(changePage(page));

    const d = values;
    d.h = this.state.h;

    const qs = parseQuery(window.location.search);
    const hash = qs.h;

    if (!d.h || d.h === 0) d.h = hash;

    this.props.dispatch(submitAssessment(d));
  }

  prevPage() {
    const page = this.props.page - 1;

    this.props.dispatch(changePage(page));
  }

  render() {
    const { page } = this.props;

    if (this.props.validateHash.status && this.props.validateHash.status !== 'available') {
      return <p>There is an error with your followup. Please contact us.</p>;
    }

    return (
      <div className="large-wrap">
        { page === 1 && <StartPage onSubmit={this.nextPage} /> }
        { page === 2 && <CurrentAct prevPage={this.prevPage} onSubmit={this.nextPage} />}
        { page === 3 && <CurrentWH prevPage={this.prevPage} onSubmit={this.nextPage} dispatch={this.props.dispatch} /> }
        { page === 4 && <CurrentSmoking prevPage={this.prevPage} smoking={this.props.smoking} smokingAmount={this.props.smokingAmount} smokingType={this.props.smokingType} onSubmit={this.nextPage} /> }
        { page === 5 && <CurrentAlcohol prevPage={this.prevPage} onSubmit={this.nextPage} /> }
        { page === 6 && <CurrentPregnant prevPage={this.prevPage} onSubmit={this.finalNextPage} /> }
        { page === 7 &&
          <AllResults
            prevPage={this.prevPage}
            height={this.props.height}
            weight={this.props.weight}
            smoking={this.props.smoking}
            smokingamount={this.props.smokingAmount}
            smokingtype={this.props.smokingType}
            activity={this.props.activityTimes}
            units={this.props.alcoholUnits}
          />
        }
      </div>
    );
  }
}

const selector = formValueSelector('assessment');

AssessmentForm.propTypes = {
  page: PropTypes.number.isRequired,
  activityTimes: PropTypes.number.isRequired,
  weight: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  smoking: PropTypes.string.isRequired,
  smokingType: PropTypes.string.isRequired,
  smokingAmount: PropTypes.string.isRequired,
  alcoholUnits: PropTypes.number.isRequired,
};

export default connect(state => ({
  weight: parseFloat(selector(state, 'assessment[curr_weight]')) || 0,
  height: parseFloat(selector(state, 'assessment[curr_height]')) || 0,
  activityTimes: parseInt(selector(state, 'exercise'), 10) || 0,
  smoking: selector(state, 'assessment[smoking]') || '',
  smokingType: selector(state, 'assessment[smoking_type_id]') || '',
  smokingAmount: selector(state, 'smokinghowmuch') || '0',
  alcoholUnits: parseInt(selector(state, 'drinking'), 10) || 0,
  page: state.assessmentPage,
  validateHash: state.validatedhash,
  login: state.login,
}), dispatch => ({ dispatch }))(AssessmentForm);



// WEBPACK FOOTER //
// ./src/Components/Assessment/index.jsx